
import {of as observableOf,  Observable } from 'rxjs';

import {map, startWith} from 'rxjs/operators';
import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { UntypedFormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessor } from '@angular/forms';

@Component({
    selector: 'ca-autocomplete-search',
    templateUrl: './autocomplete-search.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AutocompleteSearchComponent),
            multi: true
        }
    ],
    standalone: false
})
export class AutocompleteSearchComponent implements OnInit, ControlValueAccessor {
  itemSearch = new UntypedFormControl('');
  formControl = new UntypedFormControl('');

  _items: any[];

  @Input() filter: (search: string, item: any) => string;
  @Input() render: (value: any, item: any) => boolean;
  @Input()
  set items(value: any[]) {
    if (!value) {
      this.itemList = observableOf([]);
      return;
    }
    this._items = value;

    this.itemList = this.itemSearch.valueChanges.pipe(
      startWith(null),
      map(search => (search ? this.applyFilter(search) : value.slice())), );
  }

  itemList: Observable<any[]>;

  ngOnInit() {
    this.itemList = observableOf([]);
  }

  applyFilter(value: string) {
    return this._items.filter(item => this.filter(value, item));
  }

  propagateChange = (value: any) => ({});

  writeValue(value) {
    this.itemSearch.setValue(value);
    this.formControl.setValue(value);
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched() {
    // lint
  }

  public updateValue(option) {
    this.propagateChange(option.value);
  }
}
